import TeamMembers from "src/components/Shared/TeamMembers";
import TeamAboutSection from "@/components/Team/TeamAboutSection";
import TeamBanner from "@/components/Team/TeamBanner";
import TeamBoard from "@/components/Team/TeamBoard";
import TeamJoinSection from "@/components/Team/TeamJoinSection";
import SEO from "@/components/SEO";
import extractUniqueTags from "@/functions/extractUniqueTags";
import Collection from "@sourceflow-uk/sourceflow-sdk/collection";
import { useState } from "react";
import localizePath from "@/functions/localizePath";

export default function TeamPage({
  locale = "en",
  members,
  directors,
  contacts,
}) {
  const [locations] = useState(extractUniqueTags(members));

  return (
    <>
      <SEO
        path={localizePath("/team", locale)}
        title="Team | Lawrence Harvey"
        description="Our team makes magic happen."
      />
      <main className="bg-purple md:pt-[160px]  sm:min-h-screen">
        <TeamBanner />
        <div className="container">
          <TeamMembers
            color="text-white"
            hoverColor="text-purple"
            data={members}
            location={locations}
            contact={contacts}
          />
        </div>
        <div className="container">
          <TeamAboutSection />
        </div>
        <TeamBoard directors={directors} />
        <div className="container">
          <TeamJoinSection />
        </div>
      </main>
    </>
  );
}

export async function getStaticProps() {
  // prettier-ignore
  const directors = (await Collection("board_of_directors_operational_support")).getItems();
  const members = (await Collection("consultants")).getItems();
  const contacts = (await Collection("contact")).getItems();

  return {
    props: {
      members,
      directors,
      contacts,
    },
  };
}
